export default __webpack_public_path__ + "static/media/description.26c6b5c2.jpg";